import axios from "axios";
import axiosInstance from "./axiosInstance";
let isRefreshing = false;
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const refreshAccessToken = async () => {
  // If already refreshing, skip and wait

  if (isRefreshing) {
    return null;
  }
  isRefreshing = true; // Lock refresh

  try {
    const refreshToken = localStorage.getItem('refreshToken'); // Retrieve the refresh token from localStorage
    const response = await axios.post(`${API_URL}/refresh`,
      {},
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`, // Send the refresh token in the Authorization header
        },
      }
    );
    // Update tokens in storage
    localStorage.setItem('accessToken', response.data.newAccessToken);
    localStorage.setItem('refreshToken', response.data.newRefreshToken);
  } catch (error) {
    console.error('Error refreshing token', error);
    throw error;
  } finally {
    isRefreshing = false; // Unlock refresh
  }
};


export const logoutUser = async () => {
  try {
    await axiosInstance.post('/logout');
    localStorage.clear();
    window.location.href = '/signin';
  } catch (error) {
    console.error('Error during logout', error);
  }
};

